import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Favicon from "react-favicon";
import { toast, ToastContainer } from "react-toastify";
import Routes from "./routes";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import "react-form-builder2/dist/app.css";

import { CREATE_PAN_SUCCESS } from "designs/v1/pages/Address/redux/type";
import { getStageScreen } from "redux/navigation/navigationAction";
import {
  setThemeColors,
  setGradientColors,
  setCancelCheque,
  setBankStatement,
  setExchangeSegment,
  setNomineeProofvalidate,
  setReactivationProof,
  setAccountClosureScreen,
} from "designs/v1/redux/actions";

const CloseButton = ({ closeToast }) => (
  <div
    className="custom-close-button"
    onClick={closeToast}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z" />
    </svg>
  </div>
);

function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loading } = useSelector((state) => state.common);
  const navigation = useSelector((state) => state.navigation);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const favicon = window.sessionStorage.getItem("favicon");

  useEffect(() => {
    const token = window.sessionStorage.getItem("token");
    const theme = window.sessionStorage.getItem("theme_color_pallate");
    const gradient = window.sessionStorage.getItem("gradientColor");
    const cancelCheque = window.sessionStorage.getItem(
      "cancel_cheque_mandatory"
    );
    const bankStatement = window.sessionStorage.getItem(
      "statement_passbook_mandatory"
    );
    const hasNomineeProofValidate = window.sessionStorage.getItem(
      "hasNomineeProofValidate"
    );
    const hasReactivationProof = window.sessionStorage.getItem(
      "hasReactivationProof"
    );
    const accountClosureScreen = window.sessionStorage.getItem(
      "accountClosureScreen"
    );
    const exchangeSegment = window.sessionStorage.getItem("exchangeSegment");
    if (theme && gradient) {
      dispatch(setThemeColors(JSON.parse(theme)));
      dispatch(setGradientColors(JSON.parse(gradient)));
    }
    cancelCheque && dispatch(setCancelCheque(JSON.parse(cancelCheque)));
    bankStatement && dispatch(setBankStatement(JSON.parse(bankStatement)));
    hasNomineeProofValidate &&
      dispatch(setNomineeProofvalidate(JSON.parse(hasNomineeProofValidate)));
    hasReactivationProof &&
      dispatch(setReactivationProof(JSON.parse(hasReactivationProof)));
    accountClosureScreen &&
      dispatch(setAccountClosureScreen(JSON.parse(accountClosureScreen)));
    exchangeSegment &&
      dispatch(setExchangeSegment(JSON.parse(exchangeSegment)));
    if (token) dispatch(getStageScreen());
  }, [dispatch]);

  // useEffect(() => {
  //   const unlisten = history.listen((location, action) => {
  //     if (action === "POP") {
  //       const pathname = history.location.pathname.slice(1);
  //       console.log("navigation", navigation);
  //       console.log("pathname", pathname);
  //       console.log("User clicked back button");
  //       // if (navigation[0]?.PAN?.status === 1 && pathname === "pan") {
  //       //   history.push("/address");
  //       // }
  //     }
  //   });
  //   return () => {
  //     unlisten();
  //   };
  // }, [history, navigation]);

  const jointholder = useSelector((state) => state.jointholder);
  const isCloseKyc = sessionStorage.getItem("closeKYC");
  const isModifyKyc = sessionStorage.getItem("modifyKYC");

  useEffect(() => {
    if (isCloseKyc || isModifyKyc) {
      return;
    }
    if (navigation.kycStatus && navigation.pageFlow) {
      const { kycStatus, pageFlow } = navigation;
      for (const i in kycStatus) {
        const key = Object.keys(kycStatus[i]);
        const pathname = history.location.pathname.slice(1);
        if (
          kycStatus[i][key[0]]["status"] === 1 &&
          navigation.kycPageName[key[0]] === pathname
        ) {
          const nextRoute = Object.keys(pageFlow)[parseInt(i) + 1];
          const nextPage = navigation.kycPageName[pageFlow[nextRoute]];
          console.log("nextRoute-if", nextPage);
          if (nextPage !== pathname) {
            history.push(nextPage);
          }
        } else {
          const stageStatus = kycStatus.filter((obj) => {
            const key = Object.keys(obj)[0];
            return obj[key].status === 0;
          });
          const nextRoute =
            stageStatus[0]?.PAN?.pan_number_verified === 1
              ? Object.keys(stageStatus[1])[0]
              : Object.keys(stageStatus[0])[0];
          const nextPage = navigation.kycPageName[nextRoute];
          if (nextPage) {
            if (nextPage === "review" && jointholder.showJointholderFlow) {
              history.push("/joint-holder");
            } else {
              history.push(nextPage);
            }
            console.log("nextRoute-else", nextPage);
          }
          break;
        }
      }
    }
    if (navigation.kycStatus?.[0]?.PAN?.pan_doc_verified === 1) {
      dispatch({ type: CREATE_PAN_SUCCESS });
    }
  }, [navigation, dispatch, history, jointholder.showJointholderFlow, isCloseKyc, isModifyKyc]);

  useEffect(() => {
    const updateOnlineStatus = () => {
      const currentlyOnline = navigator.onLine;
      if (currentlyOnline !== isOnline) {
        setIsOnline(currentlyOnline);
        if (currentlyOnline) {
          toast.success("Back to online", {
            toastId: "online",
          });
        } else {
          toast.error(
            "You are offline. Please check your internet connection.",
            {
              toastId: "offline",
            }
          );
        }
      }
    };
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);
    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [isOnline]);

  return (
    <>
      {favicon && <Favicon url={favicon} />}
      {loading && (
        <div
          style={{
            position: "absolute",
            zIndex: 9999,
            top: 0,
            left: 0,
            right: 0,
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div style={{ height: "30%" }}></div>
          <div
            className="spinner-grow text-success"
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
          <div className="text-white">Loading...</div>
        </div>
      )}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        closeButton={<CloseButton />}
      />
      <Routes />
    </>
  );
}

export default App;
